import GameTimeSelect from './components/GameTimeSelect';
import RoundTimeSelect from './components/RoundTimeSelect';
import NewRoomModalWrapper from './components/NewRoomModalWrapper';
import RoomTypeSwitch from './components/RoomTypeSwitch';
import DiscordSwitch from './components/DiscordSwitch';
import LangSelect from './components/LangSelect';
import { getTimeOptions } from './components/getTimeOptions';
import { useLanguage } from './components/useLanguage';
import RoomLabel from './components/RoomLabel';
import WinningPointsSelect from './components/WinningPointsSelect';

import CapNewRoomModal from './CapNewRoomModal';

const newRoomModal = {
  cap: (props) =>  <CapNewRoomModal {...props}/>,
}

export {
  GameTimeSelect,
  RoundTimeSelect,
  NewRoomModalWrapper,
  RoomTypeSwitch,
  getTimeOptions,
  useLanguage,
  DiscordSwitch,
  LangSelect,
  RoomLabel,
  WinningPointsSelect,
  newRoomModal
};
